module.exports = {
  LoginManager : {},
  AccessToken : {},
}
